import { createFileRoute } from '@tanstack/react-router';
import { TokenSettingsScreen } from '../features/settings/TokenSettings.tsx';

export const Route = createFileRoute('/settings_/tokens')({ component: TokenSettingsScreen });
